var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GridVx',{ref:"AlignedGridsService",staticClass:"agGrid",staticStyle:{"height":"300px"},attrs:{"auto-size-cell":true,"columns":_vm.columnDefs,"rows":_vm.recordRowsData,"dom-layout":"scroll"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }